import React from 'react';
import {
    Show, 
    SimpleShowLayout,
    TextField,
    TopToolbar,
    EditButton,
    DeleteButton,
    DateField
} from 'react-admin';
import { hotlineBlocklistFields } from '../hotlineBlocklist.model';
import PhoneNumberField from './fields/phoneNumberField.component';
import HotlineStateField from './fields/hotlineStateField.component';
import NotesField from './fields/notesField.component';

const ShowActions = () => (
    <TopToolbar>
        <EditButton />
                        <DeleteButton 
                    mutationMode="pessimistic"
                    confirmTitle="Delete Phone Number from Blocklist"
                    confirmContent="Are you sure you want to remove this phone number from the hotline blocklist? This action cannot be undone."
                />
    </TopToolbar>
);

const HotlineBlocklistTitle = () => {
    return <span>Hotline Blocklist Entry</span>;
};

const HotlineBlocklistShow = () => {
    return (
        <Show 
            title={<HotlineBlocklistTitle />} 
            actions={<ShowActions />}
        >
            <SimpleShowLayout>
                <TextField source={hotlineBlocklistFields.id} label="ID" />
                <PhoneNumberField 
                    source={hotlineBlocklistFields.phoneNumber} 
                    label="Phone Number" 
                />
                <HotlineStateField label="Applies To" />
                <TextField 
                    source={hotlineBlocklistFields.notes} 
                    label="Notes" 
                    multiline
                    sx={{ 
                        '& .MuiTypography-root': { 
                            whiteSpace: 'pre-wrap' 
                        } 
                    }}
                />
                <DateField 
                    source={hotlineBlocklistFields.createdAt} 
                    label="Created At"
                    locales="en-US"
                    options={{
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit'
                    }}
                />
                <DateField 
                    source={hotlineBlocklistFields.updatedAt} 
                    label="Updated At"
                    locales="en-US"
                    options={{
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit',
                        second: '2-digit'
                    }}
                />
            </SimpleShowLayout>
        </Show>
    );
};

export default HotlineBlocklistShow; 